import React from 'react';

import './BaseSupSub.css';

const BaseSupSub = (props) => (
  <span>
    <div className={"basesupsub" + (props.className ? ' ' + props.className : '')}>
      <div className="base">{props.data.base}</div>
      <div className="exps">
        <div className="sup">{props.data.sup}</div>
        <div className="sub">{props.data.sub}</div>
      </div>
    </div>
  </span>
);

BaseSupSub.defaultProps = {
  data: { base: 0, sup: '', sub: '' }
}

export default BaseSupSub;


// WEBPACK FOOTER //
// ./src/components/BaseSupSub.js